import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import type { RecruitmentFormValues } from './validations';
import { ContractPreview } from './ContractPreview';

interface ContractDetailsSectionProps {
  form: UseFormReturn<RecruitmentFormValues>;
  candidateId?: string;
}

export const ContractDetailsSection: React.FC<ContractDetailsSectionProps> = ({
  form,
  candidateId
}) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <ContractPreview form={form} candidateId={candidateId} />
    </div>
  );
};
